import { ProvisioningEnum, RolloutEnum } from '@lib/resources/types';

import { SettingsFullObject } from '../types';

const settings: SettingsFullObject = {
  Waitlist: {
    sectionTitle: 'Waitlist',
    provisioning: [ProvisioningEnum.Waitlist, ProvisioningEnum.PrequalForm, ProvisioningEnum.Scheduler],
    settings: [
      [
        {
          name: 'cancellation.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.offerToJoinWaitlistOnCancellation',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 'from-both',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.autoAddToWaitlist.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'cancellation.autoAddToWaitlist.daysAhead',
          component: 'Number',
          dependencies: [{ name: 'cancellation.autoAddToWaitlist.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 14,
          required: true,
          minValue: 0,
          maxValue: 180,
        },
        {
          name: 'cancellation.autoAddToWaitlist.maxDaysAhead',
          component: 'Number',
          dependencies: [{ name: 'cancellation.autoAddToWaitlist.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 0,
          required: false,
          minValue: 0,
          maxValue: 180,
        },
      ],
      [
        {
          name: 'cancellation.allowDoubleBooks',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.PrequalForm, ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.processAppointmentTypes',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.minMinutesAheadsToProcessCancellation',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 120,
          required: true,
          minValue: 0,
          maxValue: 1000000,
        },
      ],
      [
        {
          name: 'cancellation.maxDaysAheadsToProcessCancellation',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 7,
          required: true,
          minValue: 0,
          maxValue: 365,
        },
      ],
      [
        {
          name: 'cancellation.protocol',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 'parallel',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.expiration',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 30,
          required: true,
          minValue: 0,
          maxValue: 365,
        },
      ],
      [
        {
          name: 'cancellation.waitlistOfferSortOrder',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 'longest-waiting',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.spotsDiscovery.maxSpots',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 2,
          required: true,
          minValue: 0,
          maxValue: 500,
        },
      ],
      [
        {
          name: 'cancellation.spotsDiscovery.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'cancellation.spotsDiscovery.hoursAhead',
          component: 'Number',
          dependencies: [{ name: 'cancellation.spotsDiscovery.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 48,
          required: true,
          minValue: 0,
          maxValue: 720,
        },
        {
          name: 'cancellation.spotsDiscovery.includeWhitespace',
          component: 'Toggle',
          dependencies: [{ name: 'cancellation.spotsDiscovery.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.requireFrontOfficeAcceptance',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist, ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.offerToJoinDuration',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 30,
          required: true,
          minValue: 0,
          maxValue: 365,
        },
      ],
      [
        {
          name: 'cancellation.maxOffersPerWaitlist',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 10,
          required: true,
          minValue: 0,
          maxValue: 500,
        },
      ],
      [
        {
          name: 'cancellation.delayOffers.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'cancellation.delayOffers.delayOn',
          component: 'Select',
          dependencies: [{ name: 'cancellation.delayOffers.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 'weekdays',
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'cancellation.delayOffers.until',
          component: 'TimeInput',
          dependencies: [{ name: 'cancellation.delayOffers.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: '1700',
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'cancellation.delayOffers.weekdaysDelay.enabled',
          component: 'Toggle',
          dependencies: [
            { name: 'cancellation.delayOffers.enabled', value: true, operator: 'eq' },
            { name: 'cancellation.delayOffers.delayOn', value: 'all-days', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'cancellation.delayOffers.weekdaysDelay.until',
          component: 'TimeInput',
          dependencies: [
            { name: 'cancellation.delayOffers.enabled', value: true, operator: 'eq' },
            { name: 'cancellation.delayOffers.delayOn', value: 'all-days', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: '1700',
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'cancellation.delayOffers.weekendsDelay.enabled',
          component: 'Toggle',
          dependencies: [
            { name: 'cancellation.delayOffers.enabled', value: true, operator: 'eq' },
            { name: 'cancellation.delayOffers.delayOn', value: 'all-days', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'cancellation.delayOffers.weekendsDelay.until',
          component: 'TimeInput',
          dependencies: [
            { name: 'cancellation.delayOffers.enabled', value: true, operator: 'eq' },
            { name: 'cancellation.delayOffers.delayOn', value: 'all-days', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: '1700',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.disableOnWeekends',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.sendYouveBeenAddedMessage',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist, ProvisioningEnum.PrequalForm, ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.cancelFutureAppointment',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.skipOfferBasedOnLastSentOffer',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.requireFutureAppointment',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.autoCreateWaitlists',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.removeAnyResourcesFromManualOffers',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'cancellation.waitlistOfferFlexibility',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist],
          readOnly: false,
          defaultValue: 'strict',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  Communication: {
    sectionTitle: 'Communication',
    provisioning: [],
    settings: [
      [
        {
          name: 'communication.suppressMessagesByProvisioning',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.filterChatsByGroupsFacilities',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.defaultChatVisibility',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 'internal',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.defaultChatCommunicationSecurity.level',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 'secure',
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'communication.defaultChatCommunicationSecurity.acknowledgedBy',
          component: 'String',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: true,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'communication.defaultChatCommunicationSecurity.acknowledgedAt',
          component: 'Date',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: true,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.sortMessagesBy',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 'unreadMessages',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.reopenChatsForUnclassifiedReplies',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'communication.minLengthToReopenChat',
          component: 'Number',
          dependencies: [{ name: 'communication.reopenChatsForUnclassifiedReplies', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 16,
          required: false,
          minValue: 1,
          maxValue: 1000,
        },
      ],
      [
        {
          name: 'communication.reopenChatsWithStatusUnassigned',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.sendAfterHoursMessageForInboundChats',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'communication.officeHours.beginAt',
          component: 'HourOnlyTimeInput',
          dependencies: [{ name: 'communication.sendAfterHoursMessageForInboundChats', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 5,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'communication.officeHours.endAt',
          component: 'HourOnlyTimeInput',
          dependencies: [{ name: 'communication.sendAfterHoursMessageForInboundChats', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 16,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.chatAssignmentOnHubSend',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 'reassign',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.chatAssignmentOnProfileSend',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 'reassign',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.blockedContacts',
          component: 'MultiContactString',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.expirePatientData.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'communication.expirePatientData.maxAgeInDays',
          component: 'Number',
          dependencies: [{ name: 'communication.expirePatientData.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: 14,
          required: false,
          minValue: 0,
          maxValue: 365,
        },
      ],
      [
        {
          name: 'communication.contactVerification.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.staffDisabledChannels',
          component: 'MultiSelect',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.limitedContacts',
          component: 'MultiContactString',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.numberMasking.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: true,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.useFacilityNumberFallback.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: true,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.useFacilityNumberFallback.phone',
          component: 'String',
          dependencies: [{ name: 'communication.useFacilityNumberFallback.enabled', value: true, operator: 'eq' }],
          provisioning: [],
          readOnly: true,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.patientInitiatedTexting.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.urlReplacers',
          component: 'LinkReplacer',
          dependencies: [],
          provisioning: [],
          readOnly: true,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.ignoreInactiveContactsToSendMessage.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.enableInboundCallForwardingToFacilityPhone',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.enableInboundCallForwardingToFacilityAlternativePhone',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.outboundMessages.multiChannelRetries.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'communication.outboundMessages.multiChannelRetries.channels',
          component: 'MultiSelect',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'communication.outboundMessages.multiChannelRetries.refs',
          component: 'MultiSelect',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.sendMessageAs.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.broadcast.secondaryVerification',
          component: 'Number',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: 500,
          required: false,
          minValue: 1,
          maxValue: 999999,
        },
      ],
    ],
  },
  Feedback: {
    sectionTitle: 'Feedback',
    provisioning: [ProvisioningEnum.Feedback],
    settings: [
      [
        {
          name: 'feedback.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'feedback.schedule',
          component: 'Number',
          dependencies: [{ name: 'feedback.forceMessageTime.enabled', value: false, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: 120,
          required: true,
          minValue: 0,
          maxValue: 43200,
        },
        {
          name: 'feedback.forceMessageTime.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'feedback.forceMessageTime.until',
          component: 'TimeInput',
          dependencies: [{ name: 'feedback.forceMessageTime.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: '1830',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'feedback.interval.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'feedback.interval.value',
          component: 'Number',
          dependencies: [{ name: 'feedback.interval.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: 2,
          required: true,
          minValue: 0,
          maxValue: 100,
        },
      ],
      [
        {
          name: 'feedback.multipleRemindersPerDay',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: 'multipleRemindersPerDay',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'feedback.limit.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'feedback.limit.value',
          component: 'Number',
          dependencies: [{ name: 'feedback.limit.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: 3,
          required: true,
          minValue: 0,
          maxValue: 100,
        },
      ],
      [
        {
          name: 'feedback.promoterUrls',
          component: 'FeedbackLink',
          dependencies: [],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'feedback.detractorUrls',
          component: 'FeedbackLink',
          dependencies: [],
          provisioning: [ProvisioningEnum.Feedback],
          readOnly: false,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  Followup: {
    sectionTitle: 'Followup',
    provisioning: [ProvisioningEnum.Followup],
    settings: [
      [
        {
          name: 'followup.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Followup],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  Forms: {
    sectionTitle: 'Forms',
    provisioning: [ProvisioningEnum.Form, ProvisioningEnum.IntakeForm, ProvisioningEnum.PrequalForm],
    validationItems: ['patientForms.sendDirectMessageForCcdaForms.directMessagingEmail'],
    settings: [
      [
        {
          name: 'patientForms.sendDirectMessageForCcdaForms.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patientForms.sendDirectMessageForCcdaForms.directMessagingEmail',
          component: 'Email',
          dependencies: [{ name: 'patientForms.sendDirectMessageForCcdaForms.enabled', value: true, operator: 'eq' }],
          provisioning: [],
          readOnly: false,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patientForms.hideProgressBarOnFormsWithJump',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Form, ProvisioningEnum.IntakeForm, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patientForms.hidePatientName',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Form, ProvisioningEnum.IntakeForm, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patientForms.allowCustomizeHeaderAndFooterPDF.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [RolloutEnum.PatientFormsNewPdf],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  General: {
    sectionTitle: 'General',
    provisioning: [],
    settings: [
      [
        {
          name: 'timezone',
          component: 'Select',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: 'America/Los_Angeles',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'useTimezoneFrom',
          component: 'Select',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: 'user',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'session.logoutTimeout',
          component: 'Number',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: 30,
          required: true,
          minValue: 1,
          maxValue: 720,
        },
      ],
      [
        {
          name: 'appointment.duration',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Waitlist, ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: 15,
          required: true,
          minValue: 0,
          maxValue: 10080,
        },
      ],
      [
        {
          name: 'patients.maxTokenAge',
          component: 'Number',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: 7,
          required: false,
          minValue: 0,
          maxValue: 180,
        },
      ],
      [
        {
          name: 'patients.loginRequireActiveContactMatch',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat, ProvisioningEnum.PrequalForm, ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: false,
        },
      ],
      [
        {
          name: 'reminder.schedulableWindow.earliest',
          component: 'HourOnlyTimeInput',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: 8,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.schedulableWindow.latest',
          component: 'HourOnlyTimeInput',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: 20,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.enabledChannels',
          component: 'MultiSelect',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: 'sms,voice,email,whatsapp',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'followup.sendImmediatelyWithPastSendAt',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patients.requireCaptcha',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patients.loginLookupInIntegrator',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Chat, ProvisioningEnum.PrequalForm, ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.disableAutomaticLinkShortening',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'communication.filterPatientMessageHistory',
          component: 'MultiSelect',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reporting.googleAnalytics.publishPatientDetails',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: true,
          defaultValue: false,
          required: false,
        },
        // reporting.eventTracking settings will be available when patient analytics is released
        //   {
        //     name: 'reporting.eventTracking.enabled',
        //     component: 'Toggle',
        //     dependencies: [],
        //     readOnly: false,
        //     defaultValue: true,
        //     required: true,
        //     minValue: null,
        //     maxValue: null,
        //   },
        //   {
        //     name: 'reporting.eventTracking.segementKey',
        //     component: 'Select',
        //     dependencies: [{ name: 'reporting.eventTracking.enabled', value: true, opeartor: 'eq' }],
        //     readOnly: false,
        //     defaultValue: '',
        //     required: false,
        //     minValue: null,
        //     maxValue: null,
        //   },
        //   {
        //     name: 'reporting.eventTracking.trackingModel',
        //     component: 'Select',
        //     dependencies: [{ name: 'reporting.eventTracking.enabled', value: true, opeartor: 'eq' }],
        //     readOnly: false,
        //     defaultValue: 'user',
        //     required: true,
        //     minValue: null,
        //     maxValue: null,
        //   },
      ],
      [
        {
          name: 'welcome.termsAgreementDate',
          component: 'Date',
          dependencies: [],
          provisioning: [],
          readOnly: true,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patients.hideMedicalRecordNumber.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patients.medicalRecordNumberCustomLabel.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'patients.medicalRecordNumberCustomLabel.customLabel',
          component: 'String',
          dependencies: [{ name: 'patients.medicalRecordNumberCustomLabel.enabled', value: true, operator: 'eq' }],
          provisioning: [],
          readOnly: false,
          defaultValue: null,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  'Inbound Referral': {
    sectionTitle: 'Inbound Referral',
    provisioning: [ProvisioningEnum.Referral],
    settings: [
      [
        {
          name: 'referral.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.useOutreachExperience.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.formLink',
          component: 'String',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: true,
          defaultValue: null,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.attempts',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: 5,
          required: true,
          minValue: 1,
          maxValue: 100,
        },
      ],
      [
        {
          name: 'referral.interval',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: 3,
          required: true,
          minValue: 1,
          maxValue: 180,
        },
      ],
      [
        {
          name: 'referral.sendReferralFax',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'referral.sendReferralFaxStatus.cancelled',
          component: 'Toggle',
          dependencies: [{ name: 'referral.sendReferralFax', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'referral.sendReferralFaxStatus.incomplete',
          component: 'Toggle',
          dependencies: [{ name: 'referral.sendReferralFax', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'referral.sendReferralFaxStatus.scheduled',
          component: 'Toggle',
          dependencies: [{ name: 'referral.sendReferralFax', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'referral.includeInternalMessagingInFollowupFax',
          component: 'Toggle',
          dependencies: [{ name: 'referral.sendReferralFax', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.schedulableWindow.earliest',
          component: 'HourOnlyTimeInput',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: 10,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.schedulableWindow.latest',
          component: 'HourOnlyTimeInput',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: 15,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.requireFullMatchForAutoSchedule',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'referral.requireSpecificMatchForAutoSchedule',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.requireMaxHoursApartFromAppointmentForAutoSchedule',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: 72,
          required: true,
          minValue: 0,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.useFacilityAlternativeNumber',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'referral.suppressExpiration.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Referral],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  Insurance: {
    sectionTitle: 'Insurance',
    provisioning: [ProvisioningEnum.Insurance],
    settings: [
      [
        {
          name: 'insurance.verification.showImageComponent.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Insurance],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'insurance.verification.showImageComponent.required',
          component: 'Toggle',
          dependencies: [{ name: 'insurance.verification.showImageComponent.enabled', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Insurance],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'insurance.eligibility.serviceTypeCodes',
          component: 'EligibilityServiceTypeSelect',
          dependencies: [],
          provisioning: [ProvisioningEnum.Insurance],
          readOnly: false,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'insurance.payor.requiredOnSave',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Insurance],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  'Outbound Referral': {
    sectionTitle: 'Outbound Referral',
    provisioning: [ProvisioningEnum.OutboundReferral],
    settings: [
      [
        {
          name: 'outboundReferral.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.OutboundReferral],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'outboundReferral.attempts',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.OutboundReferral],
          readOnly: false,
          defaultValue: 3,
          required: false,
          minValue: 1,
          maxValue: 100,
        },
      ],
      [
        {
          name: 'outboundReferral.interval',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.OutboundReferral],
          readOnly: false,
          defaultValue: 7,
          required: false,
          minValue: 1,
          maxValue: 180,
        },
      ],
      [
        {
          name: 'outboundReferral.sendReferralFax',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.OutboundReferral],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  Reminder: {
    sectionTitle: 'Reminder',
    provisioning: [ProvisioningEnum.Reminder],
    settings: [
      [
        {
          name: 'reminder.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.schedule',
          component: 'MultiSelect',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: '168,96,48',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.replies',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: 'allowed',
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'reminder.onConfirmation',
          component: 'Select',
          dependencies: [{ name: 'reminder.replies', value: 'none', operator: 'neq' }],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: 'keepLastReminder',
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'reminder.repliesForLastReminder',
          component: 'Select',
          dependencies: [
            { name: 'reminder.replies', value: 'none', operator: 'neq' },
            { name: 'reminder.onConfirmation', value: 'keepLastReminder', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: 'none',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.multipleRemindersPerDay',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: 'onlySendEarliest',
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'reminder.cancelOrConfirmAllAppointmentsInDay',
          component: 'Toggle',
          dependencies: [
            { name: 'reminder.replies', value: 'none', operator: 'neq' },
            { name: 'reminder.multipleRemindersPerDay', value: 'onlySendEarliest', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'reminder.multipleRemindersPerDayRepliesOverride',
          component: 'Select',
          dependencies: [
            { name: 'reminder.replies', value: 'none', operator: 'neq' },
            { name: 'reminder.multipleRemindersPerDay', value: 'onlySendEarliest', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: 'disabled',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.multipleRemindersPerDayShouldOnlyConsiderResourcesWithRemindersEnabledInSquiggly',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.strictConfirmCancelTextHandling',
          component: 'Toggle',
          dependencies: [{ name: 'reminder.replies', value: 'none', operator: 'neq' }],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.cancelOrConfirmAppointmentsInDayOnlyIfTypeVisible',
          component: 'Toggle',
          dependencies: [
            { name: 'reminder.replies', value: 'none', operator: 'neq' },
            { name: 'reminder.cancelOrConfirmAllAppointmentsInDay', value: true, operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.allowCancelAfterConfirm',
          component: 'Toggle',
          dependencies: [{ name: 'reminder.replies', value: 'none', operator: 'neq' }],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.forceVoiceCallsForSmsNonResponders',
          component: 'Toggle',
          dependencies: [{ name: 'reminder.replies', value: 'none', operator: 'neq' }],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.allowConfirmAfterCancel',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.allowSelfReschedule',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder, ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.allowSelfSchedule',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder, ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.disableCatchupReminders',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.rescheduleSundayToSaturday',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'reminder.treatCancellationsAsNoShows',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Reminder],
          readOnly: false,
          defaultValue: 0,
          required: true,
          minValue: 0,
          maxValue: 720,
        },
      ],
      [
        {
          name: 'reminder.sendReminderOnHolidays.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  Scheduler: {
    sectionTitle: 'Scheduler',
    provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm, ProvisioningEnum.Waitlist],
    settings: [
      [
        {
          name: 'scheduler.hoursAheadToShowAvailability',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: 2,
          required: false,
          minValue: 0,
          maxValue: 720,
        },
        {
          name: 'scheduler.maxDaysToShow',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: 30,
          required: false,
          minValue: 0,
          maxValue: 365,
        },
        {
          name: 'scheduler.reminder.hoursAheadToShowAvailability',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: 2,
          required: false,
          minValue: 0,
          maxValue: 720,
        },
        {
          name: 'scheduler.reminder.maxDaysToShow',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: 30,
          required: false,
          minValue: 0,
          maxValue: 365,
        },
      ],
      [
        {
          name: 'reminder.allowSelfRescheduleExpiry',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: 1440,
          required: false,
          minValue: 1,
          maxValue: null,
        },
        {
          name: 'reminder.rescheduleOfferSpacing',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: 0,
          required: false,
          minValue: 0,
          maxValue: 9999,
        },
      ],
      [
        {
          name: 'scheduler.timezone.showOnAvailabilitiesList',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: 'do-not-show',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'scheduler.showChatOnCompletion',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'scheduler.singleUseSchedulerLink.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'scheduler.oneClickBooking.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: false,
          required: false,
        },
      ],
      [
        {
          name: 'scheduler.zipcodeMaxDistance',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: 50,
          required: false,
          minValue: 1,
          maxValue: 1000,
        },
      ],
      [
        {
          name: 'scheduler.embeddedWidgetHtml',
          component: 'String',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler],
          readOnly: true,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'scheduler.maxAvailablitiesToRender',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: 4,
          required: false,
          minValue: 0,
          maxValue: 1000,
        },
        {
          name: 'scheduler.patientAddress.visible',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'scheduler.patientAddress.required',
          component: 'Toggle',
          dependencies: [{ name: 'scheduler.patientAddress.visible', value: true, operator: 'eq' }],
          provisioning: [ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'scheduler.patientEmailAddress.required',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'scheduler.preQualificationFormTemplate',
          component: 'PreQualificationFormSelect',
          dependencies: [],
          provisioning: [ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'scheduler.hideProviderDetails',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: false,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'scheduler.forceAppointmentTypeDuration',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'scheduler.ignoreDurationOnAvailabilityLookup',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'scheduler.displayPrimaryCareProviders',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: false,
          defaultValue: true,
          required: false,
        },
        {
          name: 'scheduler.createPatientOnLookupFailure',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Scheduler, ProvisioningEnum.PrequalForm],
          readOnly: true,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
  'Scheduler Assist': {
    sectionTitle: 'Scheduler Assist',
    provisioning: [ProvisioningEnum.SchedulerAssist, RolloutEnum.SchedulerAssist],
    settings: [
      [
        {
          name: 'schedulerAssist.displayDaysOfAppointmentHistory',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.SchedulerAssist, RolloutEnum.SchedulerAssist],
          readOnly: false,
          defaultValue: 365,
          required: false,
          minValue: 1,
          maxValue: null,
        },
        {
          name: 'schedulerAssist.displayDaysOfFutureAppointments',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.SchedulerAssist, RolloutEnum.SchedulerAssist],
          readOnly: false,
          defaultValue: 180,
          required: false,
          minValue: 1,
          maxValue: null,
        },
      ],
    ],
  },
  LumaBot: {
    sectionTitle: 'LumaBot',
    provisioning: [ProvisioningEnum.LumaBot],
    settings: [
      [
        {
          name: 'lumabot.avatar',
          component: 'Avatar',
          dependencies: [],
          provisioning: [ProvisioningEnum.LumaBot],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'lumabot.name',
          component: 'String',
          dependencies: [],
          provisioning: [ProvisioningEnum.LumaBot],
          readOnly: false,
          defaultValue: 'Bot',
          required: true,
          minValue: null,
          maxValue: 30,
          fullWidth: true,
        },
        {
          name: 'lumabot.header',
          component: 'String',
          dependencies: [],
          provisioning: [ProvisioningEnum.LumaBot],
          readOnly: false,
          defaultValue: 'Bot',
          required: true,
          minValue: null,
          maxValue: 20,
          fullWidth: true,
        },
        {
          name: 'lumabot.theme',
          component: 'Theme',
          dependencies: [],
          provisioning: [ProvisioningEnum.LumaBot],
          readOnly: false,
          defaultValue: null,
          required: true,
          minValue: null,
          maxValue: null,
        },
        {
          name: 'lumabot.filterLumabotFlowsByFacility',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.LumaBot],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
          permissionRequiredToEnable: [ProvisioningEnum.LumaBot],
        },
        {
          name: 'lumabot.includePoweredByLuma',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.LumaBot],
          readOnly: false,
          defaultValue: true,
          required: true,
          minValue: null,
          maxValue: null,
          permissionRequiredToEnable: [ProvisioningEnum.LumaBot, RolloutEnum.LumaBotPoweredByLuma],
        },
        {
          name: 'lumabot.liveChat.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.LumaBot],
          readOnly: false,
          defaultValue: false,
          required: true,
          minValue: null,
          maxValue: null,
          permissionRequiredToEnable: [ProvisioningEnum.LumaBot, RolloutEnum.LumaBotLiveChat],
        },
        // TODO: Enable `lumabot.placement` setting once the snippet is ready for that
        // {
        //   name: 'lumabot.placement',
        //   component: 'Select',
        //   dependencies: [],
        //   provisioning: [ProvisioningEnum.LumaBot],
        //   readOnly: false,
        //   defaultValue: 'right',
        //   required: true,
        //   minValue: null,
        //   maxValue: null,
        // },
        {
          name: 'lumabot.prompt',
          component: 'String',
          dependencies: [],
          provisioning: [ProvisioningEnum.LumaBot],
          readOnly: false,
          defaultValue: null,
          required: true,
          minValue: null,
          maxValue: 70,
          fullWidth: true,
        },
      ],
    ],
  },
  Telehealth: {
    sectionTitle: 'Telehealth',
    provisioning: [ProvisioningEnum.Telehealth],
    settings: [
      [
        {
          name: 'telehealth.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'telehealth.sessionReminderMinutes',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: 30,
          required: true,
          minValue: 0,
          maxValue: 720,
        },
      ],
      [
        {
          name: 'telehealth.sessionFinalReminderMinutes',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: 5,
          required: true,
          minValue: 0,
          maxValue: 720,
        },
      ],
      [
        {
          name: 'telehealth.maximumNoShowMinutes',
          component: 'Number',
          dependencies: [],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: 240,
          required: true,
          minValue: 0,
          maxValue: 720,
        },
      ],
      [
        {
          name: 'telehealth.showTimer',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'telehealth.vendor',
          component: 'Select',
          dependencies: [],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: 'twilio',
          required: true,
          minValue: null,
          maxValue: null,
        },
      ],
      [
        {
          name: 'telehealth.vendors.zoom.secretToken',
          component: 'String',
          dependencies: [{ name: 'telehealth.vendor', value: 'zoom', operator: 'eq' }],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: '',
          required: false,
          minValue: null,
          maxValue: null,
          fullWidth: true,
        },
      ],
      [
        {
          name: 'telehealth.vendors.zoom.apiAuthMethod',
          component: 'Select',
          dependencies: [{ name: 'telehealth.vendor', value: 'zoom', operator: 'eq' }],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: 'jwt',
          required: true,
          minValue: null,
          maxValue: null,
          fullWidth: true,
        },
      ],
      [
        {
          name: 'telehealth.vendors.zoom.apiKey',
          component: 'String',
          dependencies: [
            { name: 'telehealth.vendor', value: 'zoom', operator: 'eq' },
            { name: 'telehealth.vendors.zoom.apiAuthMethod', value: 'jwt', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
          fullWidth: true,
        },
      ],
      [
        {
          name: 'telehealth.vendors.zoom.apiSecret',
          component: 'String',
          dependencies: [
            { name: 'telehealth.vendor', value: 'zoom', operator: 'eq' },
            { name: 'telehealth.vendors.zoom.apiAuthMethod', value: 'jwt', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
          fullWidth: true,
        },
      ],
      [
        {
          name: 'telehealth.vendors.zoom.apiAccountId',
          component: 'String',
          dependencies: [
            { name: 'telehealth.vendor', value: 'zoom', operator: 'eq' },
            { name: 'telehealth.vendors.zoom.apiAuthMethod', value: 'oauth', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
          fullWidth: true,
        },
      ],
      [
        {
          name: 'telehealth.vendors.zoom.apiClientId',
          component: 'String',
          dependencies: [
            { name: 'telehealth.vendor', value: 'zoom', operator: 'eq' },
            { name: 'telehealth.vendors.zoom.apiAuthMethod', value: 'oauth', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
          fullWidth: true,
        },
      ],
      [
        {
          name: 'telehealth.vendors.zoom.apiClientSecret',
          component: 'String',
          dependencies: [
            { name: 'telehealth.vendor', value: 'zoom', operator: 'eq' },
            { name: 'telehealth.vendors.zoom.apiAuthMethod', value: 'oauth', operator: 'eq' },
          ],
          provisioning: [ProvisioningEnum.Telehealth],
          readOnly: false,
          defaultValue: '',
          required: true,
          minValue: null,
          maxValue: null,
          fullWidth: true,
        },
      ],
    ],
  },
  'Waiting Room': {
    sectionTitle: 'Waiting Room',
    provisioning: [ProvisioningEnum.WaitingRoom],
    settings: [
      [
        {
          name: 'waitingRoom.enabled',
          component: 'Toggle',
          dependencies: [],
          provisioning: [ProvisioningEnum.WaitingRoom],
          readOnly: false,
          defaultValue: true,
          required: false,
          minValue: null,
          maxValue: null,
        },
      ],
    ],
  },
};

export default settings;
